import { Navigate, useOutlet } from 'react-router-dom'

export const OrgIdOutlet = () => {
  const Out = useOutlet()
  if (Out === null) return <Navigate replace to="./organization" />
  return <>{Out}</>
}
